import { render, staticRenderFns } from "./CaseFreeTextSearchGrid.vue?vue&type=template&id=134fc714&scoped=true&"
import script from "./CaseFreeTextSearchGrid.vue?vue&type=script&lang=js&"
export * from "./CaseFreeTextSearchGrid.vue?vue&type=script&lang=js&"
import style0 from "./CaseFreeTextSearchGrid.vue?vue&type=style&index=0&id=134fc714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134fc714",
  null
  
)

export default component.exports